import { trimStrings } from './trim-strings';
import { isPlainObject } from './trim-strings';

/**
 * Recursively removes all properties with `undefined` values from plain objects.
 * Safely skips null, primitives, arrays (recurses into elements), and class instances (Timestamp, FieldValue, etc.).
 */
export function stripUndefined<T>(obj: T): T {
  if (obj === null || obj === undefined || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(stripUndefined) as T;
  if (!isPlainObject(obj)) return obj;
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value === undefined) continue;
    result[key] = stripUndefined(value);
  }
  return result as T;
}

/**
 * Sanitizes data for Firestore writes: trims strings and removes undefined values.
 * Use at every Firestore save boundary (updateDoc, setDoc) to prevent write errors.
 */
export function sanitizeForFirestore<T>(obj: T): T {
  return stripUndefined(trimStrings(obj));
}
